import React from "react";
import {
  Grid,
  Typography,
  Button,
  List,
  ListItem,
  ListItemText,
  ListItemAvatar,
  Avatar,
  Divider,
} from "@mui/material";
import PlayCircleRoundedIcon from "@mui/icons-material/PlayCircleRounded";
import oneImage from "../../../assets/Images/01.png";
import "../../../App.css";
import { isMobile } from "react-device-detect";

const HowItWorks = () => {
  return (
    <div className="how-it-works-container mt-10 pt-16 pb-16">
      <Grid container spacing={6}>
        <Grid
          item
          xs={12}
          sm={12}
          md={6}
          style={
            isMobile
              ? { paddingLeft: "80px" }
              : { margin: "auto", paddingLeft: "200px" }
          }
        >
          <Typography
            variant="h2"
            component="h1"
            color="black"
            style={{ fontWeight: "700", fontSize: "48px", lineHeight: "56px" }}
          >
            How It Works?
          </Typography>
          <Typography
            variant="subtitle1"
            color="black"
            style={isMobile ? { textAlign: "start" } : null}
          >
            Get your word done 5 simple steps. It’s more smoother than finding
            experts at your own.
          </Typography>
          <Button variant="outlined" startIcon={<PlayCircleRoundedIcon />}>
            Play Video
          </Button>
        </Grid>
        <Grid item xs={12} sm={12} md={6}>
          <List style={isMobile ? { width: "100%" } : { width: "70%" }}>
            <ListItem style={isMobile ? { marginLeft: "15px" } : null}>
              <ListItemAvatar>
                <Typography
                  variant="h2"
                  className="white-textstroke"
                  style={{
                    marginRight: "15px",
                    fontWeight: "700",
                    fontSize: "48px",
                    lineHeight: "56px",
                  }}
                >
                  01
                </Typography>
              </ListItemAvatar>
              <ListItemText
                primary="Post Request"
                secondary="Post your request by entering simple details about the services you need and post it."
              />
            </ListItem>
            {/* <Divider
              variant="inset"
              component="li"
              style={{ borderTop: "1px solid white" }}
            /> */}
            <ListItem style={isMobile ? { marginLeft: "15px" } : null}>
              <ListItemAvatar>
                <Typography
                  variant="h2"
                  className="white-textstroke"
                  style={{
                    marginRight: "15px",
                    fontWeight: "700",
                    fontSize: "48px",
                    lineHeight: "56px",
                  }}
                >
                  02
                </Typography>
              </ListItemAvatar>
              <ListItemText
                primary="Receive Bids"
                secondary="Receive bids from our experts within few minutes and evaluate their offers."
              />
            </ListItem>
            {/* <Divider
              variant="inset"
              component="li"
              style={{ borderTop: "1px solid white" }}
            /> */}
            <ListItem style={isMobile ? { marginLeft: "15px" } : null}>
              <ListItemAvatar>
                <Typography
                  variant="h2"
                  className="white-textstroke"
                  style={{
                    marginRight: "15px",
                    fontWeight: "700",
                    fontSize: "48px",
                    lineHeight: "56px",
                  }}
                >
                  03
                </Typography>
              </ListItemAvatar>
              <ListItemText
                primary="Create Contract"
                secondary="Select your favorite expert and create work contract with them."
              />
            </ListItem>
          </List>
        </Grid>
      </Grid>
    </div>
  );
};

export default HowItWorks;
